import { useEffect, useState } from 'react';

const STORAGE_KEY = 'sokuzai_comfort_mode';

const detectTouchTablet = () => {
    if (typeof window === 'undefined') return false;
    return window.matchMedia('(pointer: coarse)').matches && window.innerWidth < 1024;
};

/**
 * Mode Confort : agrandit lignes, polices et zones tactiles.
 * Auto-activé sur écran tactile (< 1024px), avec bascule manuelle mémorisée.
 */
export function useComfortMode() {
    const [autoDetected, setAutoDetected] = useState(detectTouchTablet);
    const [override, setOverride] = useState(() => {
        if (typeof window === 'undefined') return null;
        const v = window.localStorage.getItem(STORAGE_KEY);
        return v === null ? null : v === '1';
    });

    useEffect(() => {
        if (typeof window === 'undefined') return undefined;
        const mql = window.matchMedia('(pointer: coarse)');
        const recompute = () => setAutoDetected(detectTouchTablet());
        mql.addEventListener?.('change', recompute);
        window.addEventListener('resize', recompute);
        return () => {
            mql.removeEventListener?.('change', recompute);
            window.removeEventListener('resize', recompute);
        };
    }, []);

    const comfort = override !== null ? override : autoDetected;

    const toggleComfort = () => {
        const next = !comfort;
        setOverride(next);
        window.localStorage.setItem(STORAGE_KEY, next ? '1' : '0');
    };

    return { comfort, toggleComfort, autoDetected };
}
